import axios from 'axios'

let baseURL
let axiosInstance = null


if (process.env.NODE_ENV == "development") {
    baseURL = 'http://127.0.0.1:3000'
}

axiosInstance = axios.create({
    baseURL: baseURL
})

export default ({ app, router, store, Vue }) => {
    console.log('init axios_helper')
    Vue.prototype.$axios = axiosInstance
}



// WEBPACK FOOTER //
// ./src/utils/axios_helper.js